import { render, staticRenderFns } from "./NfcTagRegistration.vue?vue&type=template&id=5250e3c0"
import script from "./NfcTagRegistration.vue?vue&type=script&lang=js"
export * from "./NfcTagRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports